import { useIdDocMachine } from '../components/machine-provider';

export default useIdDocMachine;
